import React, { useContext, useState, createContext } from 'react'
export const MODALS = {
  ADD_BOOK_PACKAGE: 'ADD_BOOK_PACKAGE',
  EDIT_BOOK_PACKAGE: 'EDIT_BOOK_PACKAGE',
  DELETE_BOOK_PACKAGE: 'DELETE_BOOK_PACKAGE',
  PERMISSION_BOOK_PACKAGE: 'PERMISSION_BOOK_PACKAGE',
}

const ModalContext = createContext({
  state: undefined,
  handleOpenModal: ()=>{},
  handleCloseModal: ()=>{},
});

export const useModal = () => {
  const context = useContext(ModalContext)
  if (!context) {
    throw new Error("Modal hasn't been initialized");
  }

  return context;
}

export const ModalProvider=({children})=> {
  const [state, setState] = useState(undefined)
  const handleOpenModal =(modal)=>{
    setState(modal)
  }
  const handleCloseModal = ()=>{
    setState(undefined)
  }
  return (
    <ModalContext.Provider value={{state, handleOpenModal, handleCloseModal}}>
      {children}
    </ModalContext.Provider>
  )
}